const basic = {
  blue: "#10437D",
  lighterblue: "#165297",
  lightestblue: "#D1DCEB",
  orange: "#F09103",
  darkestgrey: "#666666", // heading
  darkergrey: "#4A535A", // normal text
  darkgrey: "#7B8A96", // legal
  lightgrey: "#B0B9C0", // footer
  lightergrey: "#DEDEDE",
  lightestgrey: "#EAEFF2",
  green: "#57BE4A",
  white: "#FFFFFF",
}

const basicRGB = {
  lightestgrey: "234,239,242",
}

export default {
  ...basic,
  rgb: basicRGB,
  footer: basic.lightgrey,
  hr: basic.lightergrey,
  headerText: basic.lighterblue,
  white: basic.white,
}
